/**
The main entry point for the Kit.

Referenced by the product.kit.liquid template.
* */
import React from 'react';
import ReactDOM from 'react-dom';
import './scss/templates/product-kit.scss';
import { KitLoader } from './apps/kit';
import Breadcrumbs from './components/Breadcrumbs';
import OVApp from './utils/OVContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var PRODUCT_ID = window.OV.PRODUCT_ID;
/**
 * Initialize the root React component
 */

var init = function init() {
  var kitEl = document.getElementById('kit');
  ReactDOM.render( /*#__PURE__*/_jsxs(OVApp, {
    children: [/*#__PURE__*/_jsx(Breadcrumbs, {
      pageTitle: "Kits"
    }), /*#__PURE__*/_jsx(KitLoader, {
      loadingHTML: kitEl.innerHTML,
      shopifyId: PRODUCT_ID
    })]
  }), kitEl);
};

init();